import { render, staticRenderFns } from "./Remainder.vue?vue&type=template&id=1d871f21&scoped=true&"
import script from "./Remainder.vue?vue&type=script&lang=js&"
export * from "./Remainder.vue?vue&type=script&lang=js&"
import style0 from "./Remainder.vue?vue&type=style&index=0&id=1d871f21&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d871f21",
  null
  
)

export default component.exports